

<div *ngIf="result?.totalResults" class="search__total-results">{{'total_results' | transloco}} <strong>{{ result?.totalResults }}</strong></div>

<ul class="search__results">
  <li *ngFor="let item of result?.items" class="search__results__result">
    <app-article-result [article]="item" [higlight]="searchString"></app-article-result>
  </li>
</ul>

<div *ngIf="!result?.items?.length && searchString?.length > 0 && !loading" class="search__no-results">
  {{'not_found' | transloco}}
</div>

<ul class="search__paginattion">
  <li *ngFor="let page of pages, let i = index" (click)="search(searchString, i)" [ngClass]="{'is-active': i == result?.page}">
    {{ i + 1 }}
  </li>
</ul>
